import axios from "axios";
import BASE_URL from "../_helpers/constants";
import { readCurrentUser } from "../_helpers/currentUser";
import { uploadDocument } from "./common.services";

// Pooled inbox SP1 (contract: Astra-Backend docs/superpowers/plans/…-sp1-plan.md).
// Each function returns the axios response like the rest of the service layer;
// callers read `res.data`. Nothing here ever sends a sender — the server derives it.
const authHeaders = () => ({
  Authorization: `Bearer ${readCurrentUser()?.token ?? ""}`,
});

export const getMyThread = () =>
  axios.get(`${BASE_URL}/threads/me`, { headers: authHeaders() });

export const getThreadMessages = (threadId, { before, limit } = {}) =>
  axios.get(`${BASE_URL}/threads/${threadId}/messages`, {
    headers: authHeaders(),
    params: { before, limit },
  });

export const sendThreadMessage = (
  threadId,
  { text = "", attachments = [] } = {},
) =>
  axios.post(
    `${BASE_URL}/threads/${threadId}/messages`,
    { text, attachments },
    { headers: authHeaders() },
  );

export const markThreadRead = (threadId) =>
  axios.post(
    `${BASE_URL}/threads/${threadId}/read`,
    {},
    { headers: authHeaders() },
  );

// Uploads through the existing documents route with uploaded_from=chat, and
// returns the rows the message body needs: [{ documentId, filename, size }].
export const uploadThreadAttachments = async (files) => {
  const form = new FormData();
  files.forEach((f) => form.append("files", f));
  const res = await uploadDocument(form, "chat");
  const uploaded = res?.data?.data || [];
  return uploaded.map((d) => ({
    documentId: d.doc_id,
    filename: d.originalname,
    size: d.size,
  }));
};
